import DesignConstructionRoutes from "./DesignConstructionRoutes";
import GISRoutes from "./GISRoutes"; 
import LandAndInfraDevelopmentHeadRoutes from "./LandAndInfraDevelopmentHeadRoutes";
import MPandLBHeadRoutes from "./MPandLBHeadRoutes";
export {
    DesignConstructionRoutes,
    GISRoutes,
    LandAndInfraDevelopmentHeadRoutes,
    MPandLBHeadRoutes
};